import React from 'react';

/**
 * Tahsilat ekranlarının sağ sütunundaki bilgilendirme blokları:
 * Güvenli Ödeme, Kabul Edilen Kartlar, Güven ve Koruma.
 *
 * Üç tahsilat tipinde de aynı bileşen kullanılır — tasarım taslaklarında bu kutuların
 * sırası ve başlıkları ekrandan ekrana farklıydı; tek bileşende toplanarak
 * tutarsızlığın tekrar oluşması engellenir.
 *
 * İçerik statiktir ve yalnız bilgilendirme amaçlıdır; ödeme akışına etki etmez.
 */

// Yalnızca fiilen kabul edilen şemalar listelenir; taslaktaki Amex ve Discover
// kasıtlı olarak dahil edilmemiştir.
const CARD_BRANDS = [
    { src: '/images/cards/visa.png', alt: 'Visa' },
    { src: '/images/cards/mastercard.png', alt: 'Mastercard' },
    { src: '/images/cards/troy.png', alt: 'Troy' },
];

/**
 * Bu metinler pazarlama sloganı değil, doğrulanabilir iddialardır ve şirketin
 * sözleşme metniyle (sample-contracts/CANCELLATION_RETURN_PRIVACY.txt, md. 3.3)
 * uyumlu tutulmalıdır. Yeni madde eklenecekse önce kodda/altyapıda karşılığı olduğu
 * doğrulanmalıdır.
 *
 * Kasıtlı olarak yazılmayanlar:
 *  - "PCI DSS uyumlu altyapı": PCI-DSS uyumu ödeme SAĞLAYICISINA aittir, bize değil;
 *    sözleşme md. 3.3 bunu açıkça böyle tanımlar. "Bizim altyapımız uyumlu" demek
 *    sözleşmeyle çelişir ve dayanağı yoktur.
 *  - "256-bit" gibi şifre gücü rakamları: TLS yapılandırmasına bağlıdır, uygulama
 *    kodundan doğrulanamaz.
 */
const TRUST_ITEMS = [
    {
        icon: 'bx-lock-alt',
        title: 'SSL şifreleme ile korunan bağlantı',
        text: 'Tüm ödeme bilgileriniz şifreli bağlantı üzerinden iletilir.',
    },
    {
        icon: 'bx-shield-quarter',
        title: '3D Secure doğrulama ile güvenli ödeme',
        text: 'Kart bilgileriniz ek güvenlik katmanıyla korunur.',
    },
    {
        icon: 'bx-badge-check',
        title: 'Kart bilgileriniz saklanmaz',
        text: 'Kart verileri yalnızca ödeme sağlayıcısı tarafından işlenir.',
    },
];

const PaymentSecurityAside = () => (
    <div className="pay-aside">
        <div className="pay-aside-card d-flex align-items-start gap-3">
            <div className="pay-aside-icon pay-aside-icon--green">
                <i className="bx bx-shield-alt-2" />
            </div>
            <div>
                <div className="fw-semibold">Güvenli Ödeme</div>
                <div className="pay-aside-muted">
                    Tüm ödeme bilgileriniz SSL ile şifrelenerek korunmaktadır.
                </div>
            </div>
        </div>

        <div className="pay-aside-card">
            <div className="fw-semibold mb-2">Kabul Edilen Kartlar</div>
            <div className="d-flex flex-wrap align-items-center gap-3">
                {CARD_BRANDS.map(b => (
                    <img key={b.alt} src={b.src} alt={b.alt} className="pay-aside-brand" />
                ))}
            </div>
        </div>

        <div className="pay-aside-card">
            <div className="fw-semibold mb-3">Güven ve Koruma</div>
            {TRUST_ITEMS.map((it, i) => (
                <div key={it.icon} className={`d-flex align-items-start gap-3 ${i < TRUST_ITEMS.length - 1 ? 'mb-3' : ''}`}>
                    <div className="pay-aside-icon pay-aside-icon--slate">
                        <i className={`bx ${it.icon}`} />
                    </div>
                    <div>
                        <div className="pay-aside-strong">{it.title}</div>
                        <div className="pay-aside-muted">{it.text}</div>
                    </div>
                </div>
            ))}
        </div>
    </div>
);

export default PaymentSecurityAside;
